import { Form, Select } from 'antd'
import React, { FunctionComponent, useMemo } from 'react'

import { BUYBACK_FIELD as FIELD } from '../../../common/buybackTypes'
import { PriceEstimateSelectBoxQuery } from '../../../graphql/generated'
import { Day } from '../DateFormat/DateFormat'
import { Money } from '../Money/Money'
import { PriceEstimateSelectBoxPdfButton } from '../PriceEstimateSelectBoxPdfButton/PriceEstimateSelectBoxPdfButton'

export type MonitNode = NonNullable<
  PriceEstimateSelectBoxQuery['allMonits']
>['nodes'][number]

export interface PriceEstimateSelectBoxProps {
  priceEstimates?: MonitNode[]
  loading?: boolean
}

export const PriceEstimateSelectBox: FunctionComponent<PriceEstimateSelectBoxProps> =
  props => {
    const priceEstimateId = Form.useWatch(FIELD.PriceEstimateId)

    const options = useMemo(
      () =>
        props.priceEstimates?.map(estimate => {
          const label = (
            <div className="flex justify-between">
              <Day noData="---">{estimate?.estimateToDate}</Day>
              <Money
                amount={estimate?.cenaReal}
                decimalNumbers={0}
                noData="---"
                symbol="Kč"
                className="font-semibold"
              />
            </div>
          )

          return (
            <Select.Option
              key={estimate?.id}
              value={estimate?.id}
              label={label}
              className=""
            >
              <div>
                <div className="font-medium">{label}</div>
                {estimate?.note && (
                  <div className="text-gray-400 whitespace-normal break-words max-h-24 overflow-hidden">
                    {estimate.note}
                  </div>
                )}
              </div>
            </Select.Option>
          )
        }),
      [props.priceEstimates]
    )

    return (
      <div className="flex">
        <PriceEstimateSelectBoxPdfButton id={priceEstimateId} />
        <Form.Item
          name={FIELD.PriceEstimateId}
          label="Použít cenový odhad"
          noStyle
        >
          <Select
            className="w-full"
            placeholder="Vyberte cenový odhad"
            optionLabelProp="label"
            disabled={!props.priceEstimates?.length}
            loading={props.loading}
            allowClear
          >
            {options}
          </Select>
        </Form.Item>
      </div>
    )
  }
